import { Provider } from '@rollbar/react';
import ErrorBoundary from 'antd/lib/alert/ErrorBoundary';
import { createBrowserHistory } from 'history';
import React, { useEffect } from 'react';
import { Route, Router, Switch } from 'react-router-dom';
import calls from './api/calls';
import firebase from './api/firebase';
import './i18n';
import { AdminDashboardPage, DashboardPage, LoginPage } from './pages/Pages';
import { rollbarConfig } from './rollbar';
import './styles/styles.less';

const history = createBrowserHistory({ forceRefresh: false });

const App = () => {
  const updatePath = (path) => {
    if (history.location.pathname !== '' && history.location.pathname === path) return;
    history.replace(path);
    history.go(0);
  };

  useEffect(() => {
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      if (user != null) {
        if (await calls.auth.isAdmin()) {
          updatePath('/admin');
        } else {
          updatePath('/dashboard');
        }
      } else {
        updatePath('/');
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>
        <Router history={history}>
          <Switch>
            <Route path="/" exact component={LoginPage} />
            <Route path="/auth" component={LoginPage} />
            <Route path="/login" component={LoginPage} />
            <Route path="/dashboard" component={DashboardPage} />
            <Route path="/admin" component={AdminDashboardPage} />
          </Switch>
        </Router>
      </ErrorBoundary>
    </Provider>
  );
};

export default App;
